import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Environments } from '~admin/model/environments';
import { AdminService } from '~admin/services/admin.service';
import { CommonService } from '~util/common.service';
import { BulkCreateComponent } from '~admin/datasource/bulk-create/bulk-create.component';
import { environment } from '~environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-datasource',
  templateUrl: './datasource.component.html',
  styleUrls: ['./datasource.component.css']
})
export class DatasourceComponent implements OnInit {

  form: FormGroup;
  environments: Environments[];

  constructor(private adminService: AdminService, private commonService: CommonService,
    private dialog: MatDialog, private router: Router) { }

  ngOnInit() {

    this.form = new FormGroup({
      targetEnvironment: new FormControl(environment.production ? '3' : '1', [Validators.required]),
      datasourceName: new FormControl('RealAnalytics', Validators.required),
      datasourceConnectionName: new FormControl('', Validators.required),
      serverName: new FormControl('', Validators.required),
      databaseName: new FormControl('', Validators.required),
      createCustomFolder: new FormControl(false)
    });

    this.adminService.getEnvironments().subscribe((environments: Environments[]) => {
      this.environments = environments;
    });
  }

  create() {
    this.adminService.create(this.form.value).subscribe(() => {
      let data = {
        header: 'Success',
        message: 'New Datasource created successfuly!'
      }
      this.commonService.showDialog(data);
      this.commonService.reload();
    });
  }

  bulkCreate() {
    let dialogRef = this.dialog.open(BulkCreateComponent, {
      width: '900px',
      autoFocus: false,
      data: {
        environments: this.environments,
        env: this.form.value.targetEnvironment
      }
    });
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/datasource/datasource.component.ts